/* calculos de pago */

export const calculoSubtotalTarifa = (tarifa, cantidad, asientosSeleccionados) => {
  const cantidadTarifa = cantidad[tarifa.id] || 0;
  let precioFinal = tarifa.precio;

  const datosAsientos = asientosSeleccionados[tarifa.id];
  // mesas enteras del mapa: el precio sale del paquete de cada mesa
  if (cantidadTarifa > 0 && datosAsientos?.precioTotal != null) {
    return datosAsientos.precioTotal;
  }
  if (datosAsientos?.metadata?.precioMesa) {
    precioFinal = datosAsientos.metadata.precioMesa;
  }

  return cantidadTarifa * precioFinal;
};

export const calcularSubtotal = (tarifas, cantidad, asientosSeleccionados) => {
  return tarifas?.reduce((acc, tarifa) => {
    return acc + calculoSubtotalTarifa(tarifa, cantidad, asientosSeleccionados);
  }, 0) || 0;
};

export const calcularComision = (tarifas, cantidad, asientosSeleccionados) => {
  return tarifas?.reduce((acc, tarifa) => {
    const cantidadTarifa = cantidad[tarifa.id] || 0;
    let precioBase = tarifa.precio;

    const datosAsientos = asientosSeleccionados[tarifa.id];
    if (datosAsientos?.metadata?.precioMesa) {
      precioBase = datosAsientos.metadata.precioMesa;
    }

    if (cantidadTarifa > 0 && datosAsientos?.comisionTotal != null) {
      return acc + datosAsientos.comisionTotal;
    }
    const comisionUnitaria = !tarifa?.asumir_comision ? (tarifa?.costo_servicio || 0) : 0;
    return acc + cantidadTarifa * comisionUnitaria;
  }, 0) || 0;
};

export const formatCurrency = (value) => {
  return value.toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });
};

export const todasTarifasGratuitas = (tarifasSeleccionadas, cantidad) => {
  if (!tarifasSeleccionadas || tarifasSeleccionadas.length === 0) return false;
  return tarifasSeleccionadas.every(tarifa => {
    const cantidadSeleccionada = cantidad[tarifa.id] || 0;
    return cantidadSeleccionada > 0 && tarifa.precio === 0 && !tarifa.asientosSeleccionados?.precioTotal;
  });
};

// true si TODAS las tarifas elegidas (cantidad > 0) requieren aprobación del organizador
export const todasTarifasConAprobacion = (tarifasSeleccionadas, cantidad) => {
  const elegidas = (tarifasSeleccionadas || []).filter(t => (cantidad[t.id] || 0) > 0);
  if (elegidas.length === 0) return false;
  return elegidas.every(t => t.requiere_aprobacion === true);
};

// true si el evento tiene ALGUNA tarifa con aprobación, sin importar si ya se seleccionó cantidad.
// Sirve para mostrar "Solicitar acreditación" en el botón inicial antes de elegir nada.
export const eventoTieneTarifasConAprobacion = (tarifas) => {
  return (tarifas || []).some(t => t.requiere_aprobacion === true);
};

// true si ALGUNA tarifa elegida (cantidad > 0) requiere aprobación del organizador
export const hayTarifasConAprobacion = (tarifasSeleccionadas, cantidad) => {
  const elegidas = (tarifasSeleccionadas || []).filter(t => (cantidad[t.id] || 0) > 0);
  return elegidas.some(t => t.requiere_aprobacion === true);
};

export const hayTarifasPagas = (tarifasSeleccionadas, cantidad) => {
  if (!tarifasSeleccionadas || tarifasSeleccionadas.length === 0) return false;
  return tarifasSeleccionadas.some(tarifa => {
    const cantidadSeleccionada = cantidad[tarifa.id] || 0;
    return cantidadSeleccionada > 0 && (tarifa.precio > 0 || tarifa.asientosSeleccionados?.precioTotal > 0);
  });
};